module.exports = __webpack_public_path__ + "04_glasses_red.78a979b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer4/04_glasses_red.png
// module id = +Wnb
// module chunks = 0